'use client'

import { useEffect } from 'react'

export function usePageScrollSmooth() {
  useEffect(() => {
    // 🥷🏼 make scroll smooth for the whole page
    // 🥷🏼 if has tag link like <Link href="#worlds">Explore Worlds</Link>
    // 🥷🏼 it will be smooth scroll
    const html = document.documentElement
    html.classList.add('scroll-smooth')

    return () => {
      html.classList.remove('scroll-smooth')
    }
  }, [])
}
